import { ComponentListType, IComponentNode } from 'app/app/editor/index.functions';

export function processPageContainersUid(p: any, parentUid: string) {
    if (p.elements) {
        for (let i in p.elements) {
            if (p.elements[i].type == 'container') {
                if (p.elements[i].params.uid != '__mark') {
                    p.elements[i].params.uid = parentUid + '-' + i;
                }
                processPageContainersUid(p.elements[i], parentUid + '-' + i);
            }
        }
    }
}

export function findElementContainerUid(node: IComponentNode, uid: string): string | null {
    let container: string | null = null;
    if (!node.elements) {
        return container;
    }
    node.elements.forEach((e) => {
        if (container != null) {
            return;
        }
        if (e.params.uid == uid) {
            container = node.params.uid;
        } else {
            container = findElementContainerUid(e, uid);
        }
    });
    return container;
}

export function findAllNestedComponentsUid(node: IComponentNode, withContainers: boolean = false): Array<string> {
    let result: Array<string> = [];
    if (withContainers || node.type == 'component') {
        result.push(node.params.uid);
    }
    if (!node.elements) {
        return result;
    }
    node.elements.forEach((e) => {
        if (e.type == 'component') {
            result.push(e.params.uid);
        } else {
            result = result.concat(findAllNestedComponentsUid(e));
        }
    });
    return result;
}

function collectAllUids(layout: any, list: Set<string>) {
    if (layout?.params?.uid) list.add(layout.params.uid);
    if (layout?.elements) {
        for (const el of layout.elements) collectAllUids(el, list);
    }
}

export function generateUid(components: ComponentListType, type: string, parentUid?: string, layout?: any) {
    if (type !== 'container') {
        const uid = (i: number) => (i === 1 ? type : `${type}-${i}`);
        let i = 1;
        while (components[uid(i)]) i++;
        return uid(i);
    }

    const usedUids = new Set<string>();

    for (const key in components) usedUids.add(key);
    if (layout) collectAllUids(layout, usedUids);

    const base = parentUid ? `${parentUid}-` : `${type}-`;
    let i = 0;
    while (usedUids.has(`${base}${i}`)) i++;
    return `${base}${i}`;
}

type ConfigItem = {
    default: string;
};

type Config = {
    [key: string]: ConfigItem;
};

type Defaults = {
    [key: string]: string;
};

export function getDefaultsFields(config: Config): Defaults {
    const result: Defaults = {};

    for (const key in config) {
        if (config[key] && typeof config[key] === 'object' && 'default' in config[key]) {
            result[key] = config[key].default;
        }
    }

    return result;
}
